<template>
  <div class="home-search">
    <div class="search-header">
      <div class="search-input">
        <img
          @click="$router.go(-1)"
          src="@/assets/images/icon-back.png"
          alt=""
        />
        <van-search
          v-model="gameName"
          placeholder="搜索游戏名称"
          shape="round"
          @input="onInput"
        />
      </div>
      <div class="search-btn" @click="onSearch">搜索</div>
    </div>

    <div class="container" v-if="!hotShow">
      <div class="search-not-found" v-if="searchEmpty">
        <span>没有找到你搜索的游戏</span>
        <span>请告诉我们你要找的游戏是什么？</span>
        <div class="feedback">反馈给我们</div>
      </div>

      <div class="search-game-list">
        <h1 class="title">{{ searchEmpty ? "大家都在玩" : "搜索结果" }}</h1>

        <div
          :class="['game-list-box', searchEmpty ? 'game-list-search-box' : '']"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="暂无更多数据"
            @load="onLoad"
          >
            <div class="game-list">
              <div
                class="game-item"
                v-for="info in gameList"
                :key="info.game_id"
              >
                <div class="game-item-content" @click="getSearchGameInfo(info)">
                  <img class="game-logo" :src="info.logo_url" alt="" />
                  <div class="game-info">
                    <div class="game-info-title">
                      <h1>{{ info.game_name }}</h1>
                      <span>{{ info.discount }}</span>
                    </div>
                    <div class="game-info-desc">
                      <div class="game-info-gift">
                        <span v-if="info.wealf">福利</span>
                        <span v-if="!info.wealf && info.havaGift == 1"
                          >礼包</span
                        >
                        <span v-if="info.isBTgame">变态特权</span>
                        <span v-if="info.waterMark == 1">专属折扣</span>
                        <span
                          v-if="
                            info.havaGift == 0 &&
                            !info.isBTgame &&
                            !info.wealf &&
                            info.waterMark == 0
                          "
                          class="game-desc"
                          >{{ info.title }}</span
                        >
                      </div>
                      <div
                        class="star"
                        v-if="
                          (info.havaGift == 1 ||
                            info.isBTgame ||
                            info.wealf ||
                            info.waterMark == 1) &&
                          info.starInfo
                        "
                      >
                        <img
                          :key="star"
                          v-for="star in info.starInfo.allStar"
                          src="@/assets/images/star_all.png"
                          alt=""
                        />
                        <img
                          :key="star + 999"
                          v-for="star in info.starInfo.halfStar"
                          src="@/assets/images/star_half.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="game-tag">
                      <span v-for="tag in info.formatGameType" :key="tag">{{
                        tag
                      }}</span>
                      <span class="other-tag">{{ info.openServerDate }}</span>
                    </div>
                    <div class="game-alias" v-if="info.gameAlias">
                      同名：{{ info.gameAlias }}
                    </div>
                  </div>
                </div>
                <!-- <div class="game-item-operate">
                  <span @click="doOperate(info, 'recharge')">充值</span>
                  <span @click="doOperate(info, 'download')">下载</span>
                </div> -->
                <operateBtns :gameInfo="info" @doOperate="doOperate" />
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>

    <div class="search-home" v-if="hotShow">
      <div class="game-hot-container" v-show="uuid">
        <div class="hot-title">
          <h1>近期充值</h1>
        </div>
        <div class="game-box">
          <div
            class="game-item"
            @click="goToRecharge(item)"
            v-for="(item, i) in rechargeList"
            :key="i"
          >
            <span class="game-index">{{ i + 1 }}</span>
            <img :src="item.logoUrl" alt="" />
            <div class="game-info">
              <h1>{{ item.gameName }}</h1>
              <span>{{ item.discount }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="game-hot-container">
        <div class="hot-title">
          <h1>近期热搜</h1>
          <span @click="getHotSearchList()">刷新</span>
        </div>
        <div class="game-box">
          <div
            class="game-item"
            @click="historyItemSearch(item.game_name)"
            v-for="(item, i) in hotList"
            :key="i"
          >
            <span class="game-index">{{ i + 1 }}</span>
            <img :src="item.logo_url" alt="" />
            <div class="game-info">
              <h1>{{ item.game_name }}</h1>
              <span>{{ item.discount }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="game-hot-container history-container">
        <div class="hot-title">
          <h1>历史搜索</h1>
          <div @click="cleanHistoryGames()">
            <img src="@/assets/images/ic_delete_seven.png" alt="" />
            <span>清空</span>
          </div>
        </div>
        <div class="game-box">
          <div
            @click="historyItemSearch(item)"
            class="game-item"
            v-for="item in historyGames"
            :key="item"
          >
            <img src="@/assets/images/ic_search_history_one.png" alt="" />
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
    </div>

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters, mapActions } from "vuex";
import mixins from "@/mixin/game.js";
import gamePlatPopup from "../../components/GamePlatPopup.vue";
import { debounce } from "../../../libs/utils";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  mixins: [mixins],
  components: {
    gamePlatPopup,
    operateBtns
  },
  data() {
    return {
      gameName: "",
      gameList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchEmpty: false,
      gamePlatPopupVisible: false,
      btnType: "00",
      channelList: [],
      gameInfo: {},
      hotList: [],
      hotShow: true,
      rechargeList: [],
      historyList: [],
    };
  },
  computed: {
    ...mapGetters(["uuid", "recents", "historyGames", "isLogin"]),
  },
  mounted() {
    this.getHotSearchList();
    if (this.uuid) {
      this.rechargeList = this.recents || [];
      this.getRechargeeList();
    }
    if (!this.historyGames.length) {
      this.updateHistoryGames(this.historyList);
    } else {
      this.historyList = this.historyGames;
    }
  },
  methods: {
    ...mapActions(["updaterecents", "updateHistoryGames", "cleanHistoryGames"]),
    /**
     * 游戏账号搜索
     */
    onInput: debounce(function () {
      this.hotShow = false;
      this.gameSearch();
    }, 500),

    gameSearch() {
      this.searchEmpty = false;
      this.resetList();
      this.onLoad();
    },

    onSearch() {
      this.searchEmpty = false;
      this.resetList(); // 重置数据
      this.onLoad(); // 重新加载第一页数据
    },

    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.gameList = []; // 清空当前列表
      this.totalCount = 0;
    },

    // 清空搜索条件并重新加载全部数据
    resetSearch() {
      this.gameName = ""; // 清空搜索关键词
      this.searchEmpty = true;
      this.resetList(); // 重置数据
      this.onLoad(); // 重新加载第一页数据
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.gameListQr();
      console.log(data, "data----");
      // 如果搜索结果为空并且有搜索关键词，清空搜索条件并重新加载全部数据
      if (this.gameName && data.length === 0) {
        this.resetSearch(); // 清空搜索条件并重新加载数据
        return;
      }
      this.gameList = [...this.gameList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 根据分类查询游戏列表
     */
    async gameListQr(isSearch) {
      // debugger
      if (isSearch) {
        this.currentPage = 1;
        this.finished = false;
        this.gameList = [];
      }
      this.historyList.unshift(this.gameName);
      const uniqueArray = [
        ...new Set(
          this.historyList.filter(
            (item) => item !== null && item !== undefined && item !== ""
          )
        ),
      ];
      this.updateHistoryGames(uniqueArray);
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/getGameList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              gameName: this.gameName,
              location: "INDEX_SEARCH",
            }),
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        let list = this.gameInit(data);
        return {
          data: list,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    getSearchGameInfo(info) {
      this.$router.replace({
        path: "/detail",
        query: { gameId: info.game_id },
      });
    },

    /**
     * 获取热搜游戏
     */
    async getHotSearchList() {
      try {
        const { data } = await requestMethods(
          "/modules/search/hotSearch/getHotSearchList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            searchParams: JSON.stringify({
              version: "4.2.0.0",
            }),
          }
        );
        this.hotList = data || [];
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },

    /**
     * 充值游戏弹窗列表
     */
    async getGameByName(gameInfo) {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getGameByName.htm",
          "post",
          {
            uuid: this.uuid,
            gameName: gameInfo.game_name,
            appType: "WM",
            systemType: "IOS",
          }
        );
        this.channelList =
          data.chargeGameInfoList.map((e) => {
            return {
              ...e,
              rechargeGameId: gameInfo.game_id,
            };
          }) || [];
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },

    async doOperate(scope, chennel) {
      // if (!this.isLogin) {
      //   this.$router.push("/login");
      //   return;
      // }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.game_name,
        gameId: scope.game_id
      };
      this.gamePlatPopupVisible = true;
    },

    /**
     * 查询充值记录
     */
    async getRechargeeList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/RechargeAction/getRechargeList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            currentPage: 1,
            pageSize: 10,
          }
        );
        const uniqueArray = data.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.gameId === item.gameId)
        );
        this.rechargeList = uniqueArray.slice(0, 2) || [];
        this.updaterecents(this.rechargeList);
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },
    /**
     * 点击历史记录搜索
     */
    historyItemSearch(name) {
      this.hotShow = false;
      this.gameName = name;
      this.onSearch();
    },

    goToRecharge(info) {
      const {
        logoUrl,
        gameName,
        gameId,
        discount,
        channelName,
        channelLogoUrl,
        id,
        gameAccount,
      } = info;
      this.$router.push({
        path: "/recharge",
        query: {
          logoUrl,
          gameName,
          gameId,
          discount,
          platName: channelName,
          platUrl: channelLogoUrl,
          rechargeGameId: id,
          gameAccountNo: gameAccount,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-search {
  background: #f4f4f4;
  height: 100vh;
  overflow: hidden;
  .search-header {
    padding: 24px 35px 24px 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 9999;
    background: #fff;

    .search-input {
      position: relative;
      width: 530px;
      display: flex;
      align-items: center;

      .van-search {
        padding: 0;
        width: 485px;
      }
      .van-search__content {
        background: #f4f4f4;
      }

      input {
        width: 485px;
        height: 60px;
        background: #f4f4f4;
        border-radius: 30px;
        border: none;
        padding: 0 60px;
      }
      img {
        width: 20px;
        height: 40px;
        margin-right: 20px;
      }
    }
    .search-btn {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #ff7a3e;
      margin-right: 20px;
    }
  }
  .container {
    margin-top: 10px;

    .search-not-found {
      width: 100%;
      height: 250px;
      background: #fff;
      text-align: center;
      padding-top: 60px;

      span {
        display: block;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
        line-height: 36px;
      }
      .feedback {
        margin: 0 auto;
        width: 200px;
        height: 60px;
        background: #ff7a3e;
        border-radius: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin-top: 20px;
      }
    }

    .search-game-list {
      margin-top: 30px;
      .title {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 36px;
        color: #000000;
        line-height: 36px;
        margin-left: 39px;
        margin-bottom: 24px;
      }

      .game-list-box {
        height: calc(100vh - 200px);
        overflow: auto;
      }
      .game-list-search-box {
        height: calc(100vh - 450px);
        // overflow: auto;
      }

      .game-list {
        padding: 0 40px;
        background: #fff;
        .game-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          //   margin-bottom: 30px;
          padding: 30px 0px;
          border-bottom: 1px solid #e6e6e6;
          &:last-child {
            margin-bottom: 0;
          }
        }

        .game-item-content {
          display: flex;
          align-items: flex-start;

          .game-logo {
            width: 132px;
            height: 132px;
            margin-right: 20px;
          }
          .game-info {
            .game-info-title {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              h1 {
                max-width: 300px;
                font-weight: 600;
                font-size: 32px;
                color: #000000;
                line-height: 45px;
                margin-right: 6px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              span {
                display: block;
                padding: 5px 5px;
                font-weight: 600;
                font-size: 22px;
                color: #ffffff;
                height: 30px;
                background: #ff7a3e;
                border-radius: 4px;
              }
            }
            .game-info-desc {
              width: 280px;
              display: flex;
              align-items: center;
              margin-bottom: 20px;

              .game-info-gift {
                span {
                  padding: 4px 12px;
                  background: #f8f8f8;
                  border-radius: 4px;
                  border: 1px solid #f8f8f8;
                  font-weight: 500;
                  font-size: 18px;
                  color: #a2a2a2;
                  margin-right: 8px;
                }

                .game-desc {
                  display: block;
                  width: 360px;
                  background: #fff;
                  border: none;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .star {
                display: flex;
                align-items: center;
                img {
                  width: 24px;
                  margin-right: 8px;
                }
              }
            }
            .game-tag {
              span {
                padding: 2px 6px;
                // background: #f8f8f8;
                border-radius: 22px;
                border: 0px solid #d2d2d2;
                font-weight: 600;
                font-size: 20px;
                color: #a2a2a2;
                // margin-right: 18px;
              }
              .other-tag {
                color: #ffbe70;
              }
            }
            .game-alias {
              font-weight: 600;
              font-size: 20px;
              color: #a2a2a2;
              margin-top: 20px;
            }
          }
        }

        .game-item-operate {
          span {
            display: block;
            width: 105px;
            height: 50px;
            border-radius: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 28px;
            line-height: 50px;
            text-align: center;

            &:first-child {
              color: #ffffff;
              background: #ff7a3e;
              margin-bottom: 23px;
            }
            &:last-child {
              border: 2px solid #ff7a3e;
              color: #ff7a3e;
            }
          }
        }
      }
    }
  }

  .search-home {
    min-height: 100vh;
    background: #fff;
  }

  .game-hot-container {
    padding: 20px 30px;
    padding-bottom: 0px;

    .hot-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #000000;
      }
      span {
        color: #ff7a3e;
      }
    }
    .game-box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 20px 0;
      .game-item {
        width: 50%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        img {
          width: 90px;
          height: 90px;
          margin-right: 24px;
        }
        .game-index {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 30px;
          color: #ff7a3e;
          line-height: 42px;
          margin-right: 20px;
        }
        .game-info {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 30px;
            color: #414141;
            line-height: 42px;
            margin-bottom: 12px;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          span {
            background: #ff7a3e;
            border-radius: 2px;
            padding: 1px 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 26px;
            color: #ffffff;
          }
        }
      }
    }
  }

  .history-container {
    .hot-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #000000;
      }

      div {
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 28px;
          margin-right: 6px;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #bbbbbb;
          line-height: 37px;
        }
      }
    }
    .game-box {
      .game-item {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 25px 0px;
        img {
          width: 40px;
          height: 40px;
          margin-right: 30px;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #414141;
          line-height: 40px;
          max-width: 568px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/homeSearch/index.vue